module.exports = __webpack_public_path__ + "static/media/01 home @1x.1de435a8.jpg";